import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

export default function NotFound() {
  return (
    <div className="notfound-page">
      <div className="container notfound-inner">
        <video
          className="notfound-pet"
          autoPlay
          muted
          loop
          playsInline
          poster="/branding/petlings-pet-512.png"
          aria-hidden="true"
        >
          <source src="/branding/petlings-pet-loop.webm" type="video/webm" />
          <source src="/branding/petlings-pet-loop.mp4" type="video/mp4" />
          <img src="/branding/petlings-pet-512.png" alt="" />
        </video>
        <h1 className="notfound-code">404</h1>
        <h2 className="notfound-title">This page wandered off.</h2>
        <p className="notfound-sub">
          Even the friendliest petlings get lost sometimes. Let's get you back.
        </p>
        <div className="notfound-actions">
          <Link to="/" className="btn btn-primary">Back to home</Link>
          <Link to="/catalog" className="btn btn-ghost">Browse the catalog</Link>
        </div>
      </div>
    </div>
  );
}
